import type { ISpecEnums } from '../spec/SpecEnums';

/**
 * Class representing a FIX enumeration type.
 * Stores and manages enumeration-specific information for FIX fields,
 * including version history and deprecation status.
 */
export class EnumType {
    /** The name of the enumeration */
    public name: string | undefined = undefined;
    /** The unique identifier for the enumeration */
    public id: string | undefined = undefined;
    /** The tag number associated with this enumeration */
    public tag: number | undefined = undefined;
    /** The data type of the enumeration */
    public type: string | undefined = undefined;
    /** The code set this enumeration belongs to */
    public codeSet: string | undefined = undefined;
    /** The value of the enumeration */
    public value: string | undefined = undefined;
    /** The sort order of the enumeration */
    public sort?: number = undefined;
    /** The group this enumeration belongs to */
    public group?: string = undefined;
    /** The version when this enumeration was added */
    public added?: string = undefined;
    /** The EP version when this enumeration was added */
    public addedEP?: string = undefined;
    /** The version when this enumeration was last updated */
    public updated?: string = undefined;
    /** The EP version when this enumeration was last updated */
    public updatedEP?: string = undefined;
    /** The version when this enumeration was deprecated */
    public deprecated?: string = undefined;
    /** The EP version when this enumeration was deprecated */
    public deprecatedEP?: string = undefined;
    /** A description of the enumeration */
    public description?: string = undefined;

    /**
     * Sets the enumeration properties based on the provided enumeration specification.
     *
     * @param {ISpecEnums} enumType - The enumeration specification to set
     */
    public setEnumeration(enumType: ISpecEnums): void {
        this.name = enumType.name;
        this.id = enumType.id;
        this.tag = enumType.tag;
        this.type = enumType.type;
        this.codeSet = enumType.codeSet;
        this.value = enumType.value;
        this.sort = enumType.sort;
        this.group = enumType.group;
        this.added = enumType.added;
        this.addedEP = enumType.addedEP;
        this.updated = enumType.updated;
        this.updatedEP = enumType.updatedEP;
        this.deprecated = enumType.deprecated;
        this.deprecatedEP = enumType.deprecatedEP;
        this.description = enumType.description;
    }
}
